import React from "react";
import Avatar, { AvatarProps } from "@mui/material/Avatar";

import { JUPITER_AVATAR } from "../../utils/constants";

const JupiterAvatar: React.FC<Omit<AvatarProps, "src">> = (props) => {
  return (
    <Avatar
      src={JUPITER_AVATAR}
      {...(props || {})}
      sx={{
        width: 65,
        height: 65,
        transition: "transform .2s",
        cursor: "pointer",
        "&:hover": {
          transform: "scale(1.1)",
        },
        ...(props?.sx || {}),
      }}
    />
  );
};

export default JupiterAvatar;
